import React from 'react'
import { render } from 'react-dom'
import { reaction, observable, action, runInAction } from 'mobx'

export type ToastIntent = 'none'| 'success'| 'info'| 'warning'| 'error'
export interface ToastFormat {
  title?: string
  message: string
  intent?: ToastIntent
  timeout?: number
}
let toastRoot = null
const toasts = observable.array()
const clearMessage = action((msgObj) => {
  if (msgObj?.id) {
    const idx = toasts.findIndex(({id}) => id === msgObj.id)
    toasts.splice(idx, 1)
  }
})
let toastId = 1
let toaster = {
  show(msgObj: ToastFormat) {
    if (typeof window == 'undefined') {
      return
    }
    const toShow = {...msgObj, id: toastId++}
    if (!toastRoot) {
      import('component-index/Toaster').then(action(Toaster => {
        toastRoot = document.createElement('div')
        toastRoot.setAttribute('class','admin-toasts-root')
        document.body.appendChild(toastRoot)
        render(<Toaster.default
          notificationsSource={toasts}
          position="top-right"
          onCancelAction={clearMessage}
          cancelMessage=''
        />, toastRoot)
        toasts.push(toShow)
      }))
    } else {
      runInAction(() => toasts.push(toShow))
    }
  }
}

export function initToaster (uistore) {
  reaction(
    () => uistore.toastError?.message,
    () => {
      if (!uistore.toastError) {
        return
      }
      let toSend = Object.assign({}, uistore.toastError)
      if (typeof toSend.message === 'object') {
        toSend.message = toSend.message.message
      }
      if (!toSend.intent || toSend.intent === 'danger') {
        toSend.intent = 'error'
      }
      if (!toSend.timeout) {
        toSend.timeout = 4000
      }
      if (toSend.message || toSend.title) {
        toaster.show(toSend)
      }
      uistore.toastError = null
    },
    {fireImmediately: true}
  )
}
export default toaster
